<!-- <div *ngIf="!loading"> -->
    <div #mapElement style="height: 500px"></div>
    <!-- <google-map #map width="100%" [options]="options">
        <map-marker
        [position]="options?.center"></map-marker>
    </google-map>
    {{address}}
  </div> -->